import {
    AppBar,
    Box,
    Container,
} from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AppFooter } from './footer';

import { HeaderComponents } from './header';


export const Root = () => {

    return (
        <Box>
            <AppBar position='static'>
                <Container maxWidth='xl'>
                    <HeaderComponents />
                </Container>
            </AppBar>
            <Outlet />
            <AppFooter />
        </Box>
    );
};
